import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4cc3df93&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc3df93')) {
      api.createRecord('4cc3df93', component.options)
    } else {
      api.reload('4cc3df93', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=4cc3df93&", function () {
      api.rerender('4cc3df93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/hotsugg/Index.vue"
export default component.exports